import { render, staticRenderFns } from "./product-price-group.vue?vue&type=template&id=7f836e26&"
import script from "./product-price-group.vue?vue&type=script&lang=js&"
export * from "./product-price-group.vue?vue&type=script&lang=js&"
import style0 from "./product-price-group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports